<template lang="html">
  <div class="account-container">
    <b-row>
      <b-col class="d-flex">
        <div class="d-inline-flex">
          <avatar-uploader />
        </div>

        <div class="d-inline-flex align-self-center">
          <b-row>
            <b-col class="ml-4">
              <div class="d-block">
                <h5 class="text-capitalize mr-2">
                  {{ userProfile ? userProfile.name : "" }}
                </h5>
                <p class="role stats-text text-capitalize">
                  {{ userProfile ? userProfile.role : "" }}
                </p>
              </div>

              <div class="d-block">
                <div class="d-inline stats-block">
                  <span class="stats-number">
                    {{ loadingData ? "∞" : userProfile.capsule_count }}
                  </span>
                  <span class="stats-text">Capsules</span>
                </div>

                <div class="d-inline ml-4 stats-block">
                  <span class="stats-number">
                    {{ loadingData ? "∞" : userProfile.stitch_count }}
                  </span>
                  <span class="stats-text">Stitches</span>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-nav tabs class="mt-4">
          <b-nav-item active class="text-uppercase">Change Password</b-nav-item>
        </b-nav>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="account-content">
          <b-form @submit="onSubmit" class="clearfix">
            <b-form-group
              id="currentPasswordInputGroup1"
              label-for="currentPasswordInput1"
            >
              <b-form-input
                id="currentPasswordInput1"
                type="password"
                v-model="form.currentPassword"
                required
                placeholder="Current password"
              />
            </b-form-group>

            <b-form-group
              id="newPasswordInputGroup1"
              label-for="newPasswordInput1"
            >
              <b-form-input
                id="newPasswordInput1"
                type="password"
                v-model="form.newPassword"
                required
                placeholder="New password"
              />
            </b-form-group>
            <b-button type="submit" class="float-right" variant="unstitched">
              Submit
            </b-button>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AvatarUploader from "@/components/account/AvatarUploader";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AvatarUploader
  },

  mounted() {
    window.analytics.page("Account");

    this.loadingData = true;
    this.fetchUserProfile(this.currentUser.username).then(response => {
      this.loadingData = false;
    });
  },

  data() {
    return {
      loadingData: true,
      form: {
        currentPassword: "",
        newPassword: ""
      }
    };
  },

  computed: {
    ...mapGetters(["currentUser", "userProfile"])
  },

  methods: {
    ...mapActions([
      "handleUpdateUserDetails",
      "handleUpdateUserPassword",
      "fetchUserProfile"
    ]),

    onSubmit(evt) {
      evt.preventDefault();

      const payload = {
        userId: this.currentUser.id,
        currentPassword: this.form.currentPassword,
        newPassword: this.form.newPassword
      };

      this.handleUpdateUserPassword(payload).then(() => {
        this.clearForm();
      });
    },

    clearForm() {
      this.form.currentPassword = "";
      this.form.newPassword = "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.role {
  margin-top: -5px;
  font-weight: 100;
}
.stats-number {
  color: $primary-blue;
  font-size: 1.2rem;
  font-weight: 400;
}

.stats-text {
  color: grey;
  font-size: 0.8rem;
  font-weight: 300;
}

.nav-tabs .nav-link {
  background-color: #f9f9f9;
  color: $primary-blue;
  letter-spacing: 1px;
}

.account-content {
  padding: 15px;
  padding-top: 30px;
  background-color: #f9f9f9;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  border-left: 1px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/pages/Users/Account.vue